import { select, on, toggleClass, selectAll, addClass, removeClass } from 'helpers/dom'
import './custom-select-dropdown.css'

const selectors = {
  SELECT_DROPDOWN_SELECTOR: '.js-select-dropdown',
  SELECTED_VALUE_DROPDOWN_SELECTOR: '.js-selected-value',
  LABEL_SELECTED_VALUE_DROPDOWN_SELECTOR: '.js-label-selected-value',
  DROPDOWN_WRAPPER_SELECTOR: '.js-dropdown-wrapper',
  DROPDOWN_ITEM_SELECTOR: '.js-dropdown-item',
  ERROR_MESSAGE_SELECTOR: '.js-input-error-message',
  ACTIVE_CLASS: 'is-active',
  OPEN_CLASS: 'is-open',
  INVALID_CLASS: 'is-invalid',
  HIDE_LABEL_CLASS: 'is-hide-label'
}

class CustomSelectDropdown extends HTMLElement {
  constructor() {
    super()

    this.selectDropdownEl = select(selectors.SELECT_DROPDOWN_SELECTOR, this)
    this.selectedValueEl = select(selectors.SELECTED_VALUE_DROPDOWN_SELECTOR, this)
    this.labelSelectedValueEl = select(selectors.LABEL_SELECTED_VALUE_DROPDOWN_SELECTOR, this)
    this.dropdownWrapperEl = select(selectors.DROPDOWN_WRAPPER_SELECTOR, this)
    this.dropdownItemEls = selectAll(selectors.DROPDOWN_ITEM_SELECTOR, this)
    this.defaultValue = this.dataset?.default
    this.hasMultipleValues = this.hasAttribute('multiple-value')
    this.multipleValues = this.dataset?.default?.split(', ') || []
  }

  connectedCallback() {
    if (this.defaultValue) {
      this.setDefaultValue()
    }
    this.attachEvents()
  }

  getDropdownValues(value) {
    if (this.hasMultipleValues) {
      const valueIndex = this.multipleValues.indexOf(value)

      if (valueIndex !== -1) {
        this.multipleValues.splice(valueIndex, 1)
      } else {
        this.multipleValues.push(value)
      }

      return this.multipleValues.join(', ')
    }

    return value
  }

  attachEvents() {
    if (this.selectDropdownEl) {
      on(
        'click',
        () => {
          this.dropdownWrapperEl && toggleClass(selectors.OPEN_CLASS, this.dropdownWrapperEl)
        },
        this.selectDropdownEl
      )
    }

    if (this.dropdownItemEls.length > 0) {
      this.dropdownItemEls.forEach((dropdownItemEl) => {
        on(
          'click',
          () => {
            const currentValue = this.getDropdownValues(dropdownItemEl.dataset.value || dropdownItemEl.innerText)
            let selectedItemEls = dropdownItemEl

            if (dropdownItemEl.dataset.value === '' || (!this.multipleValues.length && this.hasMultipleValues)) {
              addClass(selectors.HIDE_LABEL_CLASS, this)
            } else {
              removeClass(selectors.HIDE_LABEL_CLASS, this)
            }

            if (this.multipleValues.length && this.hasMultipleValues) {
              selectedItemEls = this.dropdownItemEls.filter((item) => this.multipleValues.includes(item.dataset.value))
            }

            removeClass(selectors.ACTIVE_CLASS, this.dropdownItemEls)
            addClass(selectors.ACTIVE_CLASS, selectedItemEls)

            this.dropdownWrapperEl && removeClass(selectors.OPEN_CLASS, this.dropdownWrapperEl)

            if (this.selectedValueEl) {
              const errorMessageEl = select(selectors.ERROR_MESSAGE_SELECTOR, this)

              this.selectedValueEl.value = currentValue
              removeClass(selectors.INVALID_CLASS, this.selectedValueEl)
              errorMessageEl && errorMessageEl.remove()
            }

            if (this.labelSelectedValueEl) {
              this.labelSelectedValueEl.innerText = currentValue
            }
          },
          dropdownItemEl
        )
      })
    }

    on(
      'click',
      (e) => {
        if (this && !this.contains(e.target)) {
          this.dropdownWrapperEl && removeClass(selectors.OPEN_CLASS, this.dropdownWrapperEl)
        }
      },
      document
    )
  }

  setDefaultValue() {
    if (this.dropdownItemEls.length > 0) {
      const indexDefaultValue = this.dropdownItemEls.findIndex((item) => item.dataset.value === this.defaultValue)

      if (indexDefaultValue !== -1) {
        const defaultValue =
          this.dropdownItemEls[indexDefaultValue].dataset.value || this.dropdownItemEls[indexDefaultValue].innerText

        if (defaultValue && defaultValue !== '' && this.selectedValueEl && this.labelSelectedValueEl) {
          removeClass(selectors.ACTIVE_CLASS, this.dropdownItemEls)
          addClass(selectors.ACTIVE_CLASS, this.dropdownItemEls[indexDefaultValue])
          this.selectedValueEl.value = defaultValue
          this.labelSelectedValueEl.innerText = defaultValue
        }
      }
    }
  }
}

if (!customElements.get('custom-select-dropdown')) {
  customElements.define('custom-select-dropdown', CustomSelectDropdown)
}
